module.exports = __webpack_public_path__ + "media/images/reporting-recommendation-questions-2550f348e5ac9b513b077dda4b702c3d.png";